import { useEffect, useState } from 'react'

import { GroupedTable } from '@/core/db/db'
import { useDbClientContext } from '@/context/__project__/DbClientContext'

export function useGetTablesGroup() {
  const { dbClient } = useDbClientContext()

  const [groupedTables, setGroupedTables] = useState<GroupedTable[]>([])

  useEffect(() => {
    if (!dbClient || !dbClient.opened) return

    const handleUpdate = () => {
      setGroupedTables(dbClient.groupedTables)
    }

    handleUpdate()

    const unsubscribe = dbClient.subscribe(() => {
      handleUpdate()
    })

    return () => {
      unsubscribe()
    }
  }, [dbClient])

  return [groupedTables, setGroupedTables] as const
}
